import { Component, OnInit, HostListener, Inject, Injector } from '@angular/core';
import { faChevronLeft, faChevronRight } from '@fortawesome/fontawesome-free-solid';
import { Global } from './../globals'
import { AlertService, AuthenticationService, CryptoService, LocationServiceProvider, SignalRService, StorageServiceProvider } from './../_services/services';

import fontawesome from '@fortawesome/fontawesome';
import { environment } from '../../environments/environment';
import { AppSettingsServiceProvider } from '../_services/app-settings.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ServiceLocator } from '../locater.service';
import { TestLoginComponent } from '../_directives/testLogin/test-login.component';
import * as Sentry from '@sentry/angular';
import { DialogCloseService } from '../_services/dialogClose.service';
import { SentryLoggingService } from '../_services/sentry.service';
import { ASRAppSettings, PendingAgreementsConfiguration, StorageKeys } from '../_constants';
import { PendingAgreementConfig } from '../_models/booking/pending-agreement-config';
import { Title } from '@angular/platform-browser';
import { filter, map, startWith, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import Utils from '../utils';
import { VersionCheckService } from '../_services/version_check_service';
import { Observable } from 'rxjs';
import { MatOptionSelectionChange } from '@angular/material/core';
import { UntypedFormControl } from '@angular/forms';
import { Settings } from '../_models/settings/settings.model';
import { CustomEvents } from '../_services/custom-events';
import { ActivatedRoute, Router, NavigationStart, NavigationEnd, RouterModule } from '@angular/router';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared.module';
import { AlertModule } from 'ngx-bootstrap/alert';
import { LoadingOverlayComponent } from './shared/loading-overlay/loading-overlay.component';
import { LoadingService } from '../_services/loading.service';
import { NetworkStatusService } from '../_services/network-status.service';
import { AlertMessageComponent } from './shared/alert/alert.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule,
    LoadingOverlayComponent,
    AlertMessageComponent
  ],
})
export class AppComponent implements OnInit {
  public version: string = environment.VERSION;
  public ctdText: string;
  public ProRightsText: string;
  public LocationCodeDV: string;
  public LocationDVCode: string;
  isBookAllow: boolean = false;
  blockLocation: boolean = false;
  isSalesOrderAllow: boolean = false;
  AgentName: string = "";
  QuoteButtonName: string = "Quotes";
  dialogLst: MatDialogRef<any, any>[] = [];
  public warehouseProModuleName: string = "Warehouse_Pro";
  isOnline = true;
  public pendingAgreementConfig: PendingAgreementConfig = {
    pendingAgreementStatus: false,
    emailType: "",
    pendingBookingStatus: "",
    pendingBookingStatusDescription: "",
    pendingPrepayStatus: "",
    pendingPrepayStatusDescription: "",
    pendingOrderStatus: "",
    pendingOrderStatusDescription: "",
    pendingQuoteStatus: "",
    pendingQuoteStatusDescription: "",
    PendingSignatureRequiredStatus: false,
    ButtonQuote: "Quote",
    ButtonBooking: "Book",
    ButtonPrepay: "Prepay",
    SameBookingNumberConfig: false
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    public appSetting: AppSettingsServiceProvider,
    public cryptoService: CryptoService,
    public globals: Global,
    private router: Router,
    private authenticationService: AuthenticationService,
    private singnalRService: SignalRService,
    private alertService: AlertService,
    private appsettingService: AppSettingsServiceProvider,
    private closeDialogService: DialogCloseService,
    public sentryLogging: SentryLoggingService,
    public versionCheckService: VersionCheckService,
    public http: HttpClient,
    private storage: StorageServiceProvider,
    private matDialog: MatDialog,
    public dialog: MatDialog,
    private events: CustomEvents,
    private blockUI: LoadingService,
    private networkStatusService: NetworkStatusService,
    private injector: Injector
  ) {
    // Initialize ServiceLocator with the injector for static utility access
    ServiceLocator.injector = this.injector;
    this.globals.signalR = this.singnalRService;
    this.ctdText = window.location.href.includes('salesctd.agris.com') ? " - CTD" : "";
    if (localStorage.getItem('ProUser')) {
      this.ProRightsText = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? "- Pro" : "";
    } else {
      localStorage.setItem('ProUser', this.cryptoService.encryptString("false"));
      this.ProRightsText = this.cryptoService.dencryptString(localStorage.getItem('ProUser')) === 'true' ? "- Pro" : "";
    }
    this.networkStatusService.onlineStatus$.subscribe(status => {
      this.isOnline = status;
    });

    Sentry.getCurrentScope().setTag("version", this.version);
  }

  async ngOnInit() {
    this.events.subscribe("event:blockUnblockLoctionChange", () => {
      this.blockLocation = this.blockLocation;
      localStorage.setItem('BlockLocation', String(this.blockLocation));
    });
    this.LocationCodeDV = Utils.getLocation() + " | " + Utils.getLocationDV();

    this.router.events.pipe(
      filter(event => event instanceof NavigationStart),
      tap(() => this.matDialog.closeAll())
    ).subscribe();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    )
      .subscribe(() => {
        var rt = this.getChild(this.activatedRoute)
        rt.data.subscribe(data => {
          let settings = localStorage.getItem('settings');
          let locationCode: string | undefined;
          locationCode = Utils.getLocation();
          this.LocationDVCode = locationCode;
          if (data.title != 'App settings' || data.title != 'Login' || data.title != '') {
            if (data.title != 'Login' && data.title != 'App settings') {
              if (settings && (!locationCode || locationCode === undefined) && (data.title != 'Settings')) {
                this.titleService.setTitle(data.title)
                this.router.navigate(['/settings'], { queryParams: { LocationCode: false } });
              }
              else if (settings && (!locationCode || locationCode === undefined) && data.title == 'Settings') {
                this.titleService.setTitle(data.title)
                this.router.navigate(['/settings'], { queryParams: { LocationCode: false } });
              }
            }


          } else {
            this.titleService.setTitle(data.title)
          }



        })
      });


    this.versionCheckService.initVersionCheck(environment.VersionCheckUrl);
    fontawesome.library.add(faChevronLeft, faChevronRight);
    this.GetPendingAgreementSettings();
    let settings = this.storage.get(StorageKeys.Settings);;
    if (settings) {
      if (settings.agentSessionDate !== new Date().toLocaleDateString()) {
        this.appsettingService.GetAgentSessionId(settings.agentUsername, settings.agentEncryptedPassword, () => {
          console.log("Daily Agent session updated");
        }, (error) => {
          localStorage.clear();
          this.router.navigate(['/appsettings']);
        });
      }
      let dataSet = this.storage.get(StorageKeys.DataSet);
      if (dataSet) {
        let sentrytag = settings.agentEmail + ' - ' + dataSet.TenantName;
        Sentry.getCurrentScope().setTag("tenant", sentrytag);
      }
      let userId = localStorage.getItem('loginUserId');
      if (userId) {
        Sentry.getCurrentScope().setTag("loggedInUser", userId);
      }
      var str = settings.agentUsername;
      if (settings.agentUsername) {
        var replaceStr = str.replace('Agent:', '');
        this.AgentName = replaceStr;
      }
    }
    if (localStorage.getItem('agrisLicense')) {
      this.globals.isAuthenticated = true;
    }
    else {
      this.onLogOutResponse([]);
    }
    this.closeDialogService.registerEventListner().subscribe(dialog => {
      if (dialog)
        this.dialogLst.push(dialog);
    });

    this.getSalesProConfigurations();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (event.url.includes('login')) {
          document.body.style.backgroundColor = '#28a745';
          document.getElementsByClassName('container')[0]["style"].maxWidth = '700px';
        } else if (event.url.includes('appsettings')) {
          document.body.style.backgroundColor = 'white';
          document.getElementsByClassName('container')[0]["style"].maxWidth = '';
        } else {
          document.body.style.backgroundColor = '';
          document.getElementsByClassName('container')[0]["style"].maxWidth = '';
        }
      }
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }

  }

  @HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(event) {
    // this.authenticationService.logout();
  }


  logout() {
    this.authenticationService.releaseAgrisLicense(this.onLogOutResponse, (error) => {
      Sentry.captureMessage("Handled Error: " + JSON.stringify(error));
      console.log(error);
      this.alertService.error(error.Code == 401 ? 'Sorry, the app is unable to connect to the agent. Please try again or contact your administrator.' : 'Sorry, there is an error in processing. Please try again or contact your administrator.');
      this.blockUI.stop();
    });
  }
  onLogOutResponse = (response: any) => {

    // if (response.errorMessage) {
    //   this.alertService.error(response.errorMessage);
    //   this.blockUI.stop();
    //   return;
    // }
    // else {
    this.blockUI.stop();
    this.authenticationService.logout();
    this.router.navigate(['/login']);
    // }
  }
  testMode() {
    if (window.location.href.includes('agris.com/appsettings') == true) {
      console.log("Test Mode");
      this.testLogin();
    }
  }
  testLogin() {
    let dialogRef = this.dialog.open(TestLoginComponent,
      {
        width: '350px',
        data: {
          title: "Test Login",
        }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "test") {
        window.location.replace('https://salesctd.agris.com/appsettings');
      }
      else if (result == "exit") {
        window.location.replace('https://sales.agris.com/appsettings');
      }
    });
  }
  getPermissions() {
    let per = localStorage.getItem('UserPermission');
    this.isBookAllow = false;
    this.isSalesOrderAllow = false;
    if (per) {
      let permissions = JSON.parse(this.cryptoService.dencryptString(per));
      permissions.forEach(permission => {
        if (permission.SecurityOption == "KIMPT" && permission.Package == 'ACR' && parseInt(permission.SecurityLevel) > 1) {
          this.isBookAllow = true;
        }
        if (permission.SecurityOption == "PIMPT" && permission.Package == 'INV' && parseInt(permission.SecurityLevel) > 1) {
          this.isSalesOrderAllow = true;
        }
      });
      // console.log(permissions);
    }
    this.dialogLst.forEach(element => {
      if (element) element.close();
    });
    this.dialogLst = [];
  }
  GetPendingAgreementSettings() {

    this.blockUI.start();
    this.appSetting.GetAppSettingsFromASR(ASRAppSettings.PendingAgreementsConfiguration).then((response) => {
      let data = response.TransactionObject;
      if (data.length) {


        let ButtonQuote: any = data.find((x: any) => x.Name == PendingAgreementsConfiguration.ButtonQuote);
        if (ButtonQuote && ButtonQuote.Value) {
          this.pendingAgreementConfig.ButtonQuote = ButtonQuote.Value;
          this.QuoteButtonName = ButtonQuote.Value;
        }
        else {
          this.QuoteButtonName = "Quote";
        }

      }
      this.blockUI.stop();

    }).catch((error) => {
      if (error)
        this.alertService.error(error.Message);
      this.blockUI.stop();
    })
  }


  getSalesProConfigurations(): Promise<any> {
    let configRemoteURL = Utils.GetConfigurationRemoteServer();
    return new Promise((resolve, reject) => {
      this.getModules().then(response => {
        let moduleName = "Sales_Pro";
        let moduleId = response.filter(
          x => x.ModuleName == moduleName)[0].ModuleId;

        let agentId = this.storage.AgentID;
        var data = {
          Authorization: 'Basic YWRtaW46cGFzc3dvcmQx',
        };
        let url = `${configRemoteURL}/ModuleConfigurations?ModuleId=${moduleId}`;
        if (agentId) {
          url += `&Agent=${agentId}`;
        }

        this.http.get(url, { headers: data, })
          .pipe()
          .subscribe((response: any) => {
            if (response) {

              try {
                let value = response[0].ConfigurationValue ? JSON.parse(response[0].ConfigurationValue) : false;
                let remark = value && value.Selected ? 'true' : 'false';
                localStorage.setItem("ProUser", this.cryptoService.encryptString(remark));

                this.ProRightsText = this.cryptoService.dencryptString(localStorage.getItem("ProUser")) == "true" ? " - Pro" : "";
              }
              catch (ex) {
                //localStorage.setItem("ProUser", this.cryptoService.encryptString("false"));
              }

            }

            resolve(response);
          }, (error) => {
            if (error && error.status == 0) {
              // this.events.publish("event:ShowError", "Please check your network and try again.")
            }
            else { reject(error); }
          }
          );
      });
    });
  };



  getModules(): Promise<any> {
    return new Promise((resolve, reject) => {
      let configRemoteURL = Utils.GetConfigurationRemoteServer();
      var data = { Authorization: 'Basic YWRtaW46cGFzc3dvcmQx', };
      let url = `${configRemoteURL}/Modules`;
      let settings = this.storage.get(StorageKeys.Settings);;
      if (settings && settings.remoteServer == undefined) {
        settings.remoteServer = Utils.GetGetwayRemoteDomain();
      }
      this.http.get(url,
        { headers: data, }).pipe().subscribe((response) => {
          resolve(response);
        }, (error) => {
          if (error && error.status == 0) {
            console.log("ERRor")
          } else { reject(error); }
        })
    });
  };
  isLocationDialog = false;
  openDialog(): void {
    if (this.isLocationDialog)
      return;
    this.isLocationDialog = true;
    var BlockLocationValue = (localStorage.getItem('BlockLocation')) ? localStorage.getItem('BlockLocation') === 'true' ? true : false : false;
    if (BlockLocationValue) {
      Utils.confirmationDialog("Warning", "You cannot change the location at this moment.Please complete Your transaction first.", "close", () => {
        this.isLocationDialog = false;
      }, false);
    } else {
      const dialogRef = this.dialog.open(LocationDropDownDialog, {
        width: '400px',
        closeOnNavigation: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.isLocationDialog = false;
        if (result) {
          this.LocationCodeDV = result.Desc;
          this.LocationDVCode = result.Code;
        }
      });
    }


  }
}


export interface DialogData {
  states: string[];
  item: any;
  selectedItem: any;
  positiveKey: string;
  unitPricePrecision: number;
  productQuantityPrecision: number;
  restrictedData: any;
}
@Component({
  selector: 'Location-Drop-Down-Dialog',
  templateUrl: 'Location-Drop-Down-Dialog.html',
  standalone: true, // Required for Angular 18's new standalone components
  imports: [
    SharedModule,
    MaterialModule
  ]
  // styleUrls: [
  //     "./View-Detail-dialog.scss"
  // ]
})

export class LocationDropDownDialog {
  locationAutocomplete: UntypedFormControl;
  filteredLocations: Observable<any[]>;
  settings: Settings;
  settingsResult: Settings[] = [];
  showSpinner: boolean = false;
  resultfetched: boolean = false;
  LocationDesc: string = "";
  locations: any[];
  constructor(
    public dialogRef: MatDialogRef<LocationDropDownDialog>,
    private storage: StorageServiceProvider,
    locationService: LocationServiceProvider,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private alertService: AlertService,
    private blockUI: LoadingService,
    private closeDialogService: DialogCloseService

  ) {
    locationService.syncLocations((locations) => {
      this.locations = locations;
      this.blockUI.stop();
    });
    this.locationAutocomplete = new UntypedFormControl();

    this.settings = this.storage.get(StorageKeys.Settings) || new Settings();
    this.locationAutocomplete.setValue(this.settings.locationCode);
    dialogRef.disableClose = true;
    this.closeDialogService.emitRegisterDialog(dialogRef);
  }

  onSaveClick(): void {
    Utils.saveSettings(this.settings);
    this.dialogRef.close({ Desc: this.LocationDesc, Code: this.settings.locationCode });
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onFocus($event) {
    var topContainer = document.getElementById("topContainer");
    if (topContainer) {
      topContainer.style.display = "none";
    } else {
      console.log("topContainer does not exist!");
    }
  }
  onBlur($event) {
    var topContainer = document.getElementById("topContainer");
    if (topContainer) {
      topContainer.style.display = "block";
    } else {
      console.log("topContainer does not exist!");
    }
  }
  filterLocation(locationCode: string) {
    return this.settingsResult.filter(loc =>
      loc.code.includes(locationCode));
  }
  getitem(event: MatOptionSelectionChange, settings: any) {

    if (event.source.selected) {
      this.settings.locationCode = settings.code;
      this.settings.LocationCodeDv = settings.description;
      this.locationAutocomplete.setValue(settings.code);
      this.LocationDesc = event.source.viewValue;


    }
  }

  onSearchResponds = (response: any) => {
    this.showSpinner = false;

    if (response.length == 0) {
      this.settingsResult = null;
      this.alertService.warning('No records found.', false, true);
      this.blockUI.stop();
    } else {
      this.resultfetched = true;
      this.blockUI.stop();
      this.settingsResult = <Settings[]>response;

      this.filteredLocations = this.locationAutocomplete.valueChanges
        .pipe(
          startWith(''),
          map(loc => loc ? this.filterLocation(loc) : this.settingResultSlice(this.settingsResult))
        );

    }
  }
  searchText() {

    if (this.locationAutocomplete.value == '') {
      this.settings.locationCode = '';
    }

    if (!this.resultfetched) {
      this.showSpinner = true;
      this.blockUI.start();
      this.onSearchResponds(this.locations);
    }
  }
  settingResultSlice(settingsResult) {
    return settingsResult && settingsResult.length ? settingsResult.slice() : '';
    // return settingsResult ? settingsResult.slice() : '';
  }
}



